import * as S from './style';

function Footer() {
  // console.log('Footer');

  return (
    <S.FooterWrapper>
      <S.FooterText>
        <span>COPYRIGHT © 2025 경북연구원 ALL RIGHTS RESERVED</span>
        <br />
        <span>AI Mediacenter Project GDFLIX</span>
      </S.FooterText>
      <S.FooterBox>
        <a title="경북연구원" href="https:/gdi.re.kr/main" target='_blank' rel="noopener noreferrer" >
          <i className="fa fa-globe"></i>
        </a>
        {/* <a title="노마드코더" href="https://nomadcoders.co/" target="_blank" rel="noopener noreferrer" >
          <img src="https://nomadcoders.co/m.svg" alt="" aria-labelledby="노마드코더" aria-required="true" className="sc-ksdxgE cDENRo" />
        </a> */}
      </S.FooterBox>
    </S.FooterWrapper>
  )
}

export default Footer;
